import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const SID_KEY = "fab_sid";
const sid = () => {
  try {
    let v = sessionStorage.getItem(SID_KEY);
    if (!v) { v = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36)).replace(/-/g, ""); sessionStorage.setItem(SID_KEY, v); }
    return v;
  } catch { return null; }
};

// Privacy-safe page-view beacon: path + random per-tab session id only. Skipped when the
// cookie banner was declined. Backend attaches user_id from the session cookie when signed in.
export default function usePageTracking() {
  const { pathname } = useLocation();
  useEffect(() => {
    let consent = null;
    try { consent = localStorage.getItem("fab_cookie_consent"); } catch { /* ignore */ }
    if (consent === "declined") return;
    const s = sid();
    if (!s) return;
    api.post("/track", { path: pathname, sid: s }).catch(() => {});
  }, [pathname]);
}
